import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=d0c12976&scoped=true"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"
import style0 from "./loginForm.vue?vue&type=style&index=0&id=d0c12976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c12976",
  null
  
)

export default component.exports